export const KEYWORD_PROFILE_DETAILS_REQUEST= 'KEYWORD_PROFILE_DETAILS_REQUEST'
export const KEYWORD_PROFILE_DETAILS_SUCCESS= 'KEYWORD_PROFILE_DETAILS_SUCCESS'
export const KEYWORD_PROFILE_DETAILS_FAIL   = 'KEYWORD_PROFILE_DETAILS_FAIL'
export const KEYWORD_PROFILE_DETAILS_RESET   = 'KEYWORD_PROFILE_DETAILS_RESET'

export const KEYWORD_PROFILE_DETAILS_BY_ID_REQUEST   = 'KEYWORD_PROFILE_DETAILS_BY_ID_REQUEST'
export const KEYWORD_PROFILE_DETAILS_BY_ID_SUCCESS   = 'KEYWORD_PROFILE_DETAILS_BY_ID_SUCCESS'
export const KEYWORD_PROFILE_DETAILS_BY_ID_FAIL      = 'KEYWORD_PROFILE_DETAILS_BY_ID_FAIL'
export const KEYWORD_PROFILE_DETAILS_BY_ID_RESET     = 'KEYWORD_PROFILE_DETAILS_BY_ID_RESET'

export const KEYWORD_PROFILE_CREATE_REQUEST = 'KEYWORD_PROFILE_CREATE_REQUEST'
export const KEYWORD_PROFILE_CREATE_SUCCESS = 'KEYWORD_PROFILE_CREATE_SUCCESS'
export const KEYWORD_PROFILE_CREATE_FAIL    = 'KEYWORD_PROFILE_CREATE_FAIL'
export const KEYWORD_PROFILE_CREATE_RESET   = 'KEYWORD_PROFILE_CREATE_RESET'

export const KEYWORD_PROFILE_UPDATE_REQUEST = 'KEYWORD_PROFILE_UPDATE_REQUEST'
export const KEYWORD_PROFILE_UPDATE_SUCCESS = 'KEYWORD_PROFILE_UPDATE_SUCCESS'
export const KEYWORD_PROFILE_UPDATE_FAIL    = 'KEYWORD_PROFILE_UPDATE_FAIL'
export const KEYWORD_PROFILE_UPDATE_RESET   = 'KEYWORD_PROFILE_UPDATE_RESET'


export const KEYWORD_PROFILE_DELETE_REQUEST = 'KEYWORD_PROFILE_DELETE_REQUEST'
export const KEYWORD_PROFILE_DELETE_SUCCESS = 'KEYWORD_PROFILE_DELETE_SUCCESS'
export const KEYWORD_PROFILE_DELETE_FAIL    = 'KEYWORD_PROFILE_DELETE_FAIL'
export const KEYWORD_PROFILE_DELETE_RESET   = 'KEYWORD_PROFILE_DELETE_RESET'
